import axios from 'axios';
import Swal from 'sweetalert2';
import React, { Component } from "react";
import Confirm from '../Confirm/Confirm';
import { MDBRow, MDBCol } from "mdbreact";
import FormReingreso from '../FormReingreso/FormReingreso';

// Importar CSS Y JS
import './Header.css';
import '../../assets/js/script.js';

class Header extends Component {

    constructor(props) {
        super(props);
        this.state = { enabledSystem: true };
    }
    
    componentDidMount() {
    const URL = "https://admisiones.ufg.edu.sv/reingresoapis/api/v1";
    // const URL = "http://127.0.0.1:4003/api/v1";

    axios.get(`${URL}/enabled-system`).then(({ data = {} }) => {
      this.setState({ enabledSystem: data.habilitado });
    });

    var viewport = window.matchMedia("(max-width: 1023px)");
    this.mostrarModalRecomendaciones(viewport);
    viewport.addListener(this.mostrarModalRecomendaciones);
  }
    mostrarModalRecomendaciones=(viewport)=> {
            if(viewport.matches && !this.state.enabledSystem){
                var btnMovil = document.getElementById("btnMovil");
                btnMovil.style.display = "none";

                var formReingreso = document.getElementById("formReingreso");
                formReingreso.style.display = "none";

                var formReingresoToken = document.getElementById("formReingresoToken");
                formReingresoToken.style.display = "none";

                Swal.fire({
                    html:
                        '<div id="fondo">' +
                        '<div id="foto"></div>' +
                        '<p id="parrafoBlue">El tiempo para realizar el proceso de reingreso ha finalizado</p>' +
                        '<p id="parrafoBlue">Para más información comunícate al 2209-2834</p>' +
                        '</div>',
                    confirmButtonText: "CONTINUAR",
                    showConfirmButton: true,
                    showCloseButton: true
                })
            } 
        }
    levantarModal = () => {
        if(!this.state.enabledSystem){
            Swal.fire({
                html:
                    '<div id="fondo">' +
                    '<div id="foto"></div>' +
                    '<h2 id="colorRecomendaciones" class="futuraBold">' +
                    'LO SENTIMOS</h2>' +
                    '<p id="parrafoBlue">El tiempo para realizar el proceso de reingreso ha finalizado</p>' +
                    '<p id="parrafoBlue">Para más información comunícate al 2209-2834</p>' +
                    '</div>',
                confirmButtonText: "CONTINUAR",
                showConfirmButton: true,
                showCloseButton: true
            })
        }else{
            var reingreso = document.getElementById("reingreso");
            reingreso.style.display = "block";
        }
    }    

    render() {
        return (
            <div>
                <MDBRow>
                    <MDBCol size="12" sm="12" md="12" lg="12" xl="12" className="banner">
                    </MDBCol>
                </MDBRow>

                <MDBRow className="cajaOpacidad wow bounceInLeft animated">
                    <MDBCol size="12" sm="5" md="5" lg="5" xl="5" className="opacidad offset-size-7 offset-sm-7 offset-md-7 offset-lg-7 offset-xl-7">
                    </MDBCol>
                </MDBRow>

                <MDBRow className="cajaTitulos wow bounceInLeft animated">
                    <MDBCol size="12" sm="5" md="5" lg="5" xl="5" className="titulosBanner offset-size-7 offset-sm-7 offset-md-7 offset-lg-7 offset-xl-7">
                        <h1 className="tituloBanner">SOLICITUD DE <span className="futuraBold">REINGRESO</span></h1>
                        <button className="boton orangeReingreso marginTop" onClick={this.levantarModal}>
                            INICIAR
                        </button>
                        <center>
                            <a href="#formReingreso" className="boton orangeReingresoMovil" id="btnMovil">
                                INICIAR
                            </a>
                        </center>
                    </MDBCol>
                </MDBRow>

                <div id="reingreso" className="reingreso">
                    <div className="modalContentReingreso">
                        {/*<span className="close4">&times;</span>*/}
                        <FormReingreso>
                        </FormReingreso>
                    </div>
                </div>
                <Confirm></Confirm>
            </div >
        );
    }
}
export default Header;